import LocationIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/location';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import PriceCta from '../PriceCta';

import STYLES from './InformationHeader.module.scss';

import ResponsibleImage from '@hotels-hotel-detail/ui/ResponsibleImage';
import { TABLET_WIDTH } from '@hotels-hotel-detail/ui/ResponsibleImage/media-width';
import HotelStars from '@shared/ui/components/HotelStars';

type Props = {
  name: string;
  mainImg?: string;
  numberOfStars: number;
  address: string;
  onClose: Function;
};

const InformationHeader = ({
  address,
  mainImg,
  name,
  numberOfStars,
  onClose,
}: Props) => (
  <div>
    <div className={STYLES.InfomationHeader__imgContainer}>
      <ResponsibleImage
        name={name}
        className={STYLES.InfomationHeader__img}
        image={mainImg}
        sizes={[
          {
            maxQuery: TABLET_WIDTH,
            w: 94,
            h: 77,
          },
          {
            w: 500,
            h: 140,
          },
        ]}
      />
    </div>

    <div className={STYLES.InformationHeader__textContainer}>
      <div className={STYLES.InformationHeader__nameContainer}>
        <BpkText
          textStyle={TEXT_STYLES.heading4}
          className={STYLES.InfomationHeader__name}
          tagName="h1"
          color={TEXT_COLORS.textPrimary}
        >
          {name}&nbsp;
        </BpkText>
        <HotelStars
          className={STYLES.InformationHeader__stars}
          stars={numberOfStars}
        />
      </div>
      <BpkText
        textStyle={TEXT_STYLES.caption}
        tagName="p"
        className={STYLES.InformationHeader__address}
      >
        <LocationIcon className={STYLES.InformationHeader__locationIcon} />
        {address}
      </BpkText>

      <PriceCta onClose={onClose} />
    </div>
  </div>
);

export default InformationHeader;
